module.exports = "/_next/static/images/os_windows-2327c092324803d82e7cc191d6f2e39c.svg";